import { trackEvent, useCurrentLocale } from '@finn/ui-utils';
import { forwardRef } from 'react';

import { useModuleDefaults } from '../../services/content/useModuleDefaults';
import { DecagonChat } from './DecagonChat';
import { ChatRef } from './types';

type ChatProps = {
  translations?: { [key: string]: string };
  variant?: 'zendesk' | 'ultimate' | 'decagon';
  feature_flags?: {
    chatbot_provider?: 'zendesk' | 'ultimate' | 'decagon';
  };
};

const handleChatOpen = () => {
  trackEvent('Chat Opened', {});
};

export const Chat = forwardRef<ChatRef, ChatProps>((props, ref) => {
  const { locale } = useCurrentLocale();
  const [, isLoading] = useModuleDefaults('chat', locale);
  const variant =
    props.variant || props.feature_flags?.chatbot_provider || 'zendesk';

  // if chat used outside platform, we need to wait for translations to be loaded
  if (isLoading && !props.translations) {
    return null;
  }

  switch (variant) {
    default:
      return <DecagonChat onChatOpened={handleChatOpen} ref={ref} />;
  }
});

export * from './DecagonChat';
export * from './types';
